export enum PaypalMode {
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
  PAYPAl_CODE = 9,
}
